import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
// import { environment } from "src/environments/environment";
   
@Injectable({
    providedIn: "root"
})
export class SeguridadService{

    // async obtenerToken(){
    //     let url=`http://www.solitest.com.co:8083/ApiSolidariaUtilidades/api/oauth/token`;
    //     let body={
    //         "transaction": 0,
    //         "nameAplication": "Jarango",
    //         "passwordAplication": "Jarango",
    //         "activeAplication": true,
    //         "token": "string"
    //     };
    //     let request: RequestInit={
    //         body: JSON.stringify(body),
    //         method: 'POST',
    //         headers: {
    //             'Content-Type': 'application/json',
    //             'Access-Control-Allow-Origin': '*',
    //             'Accept': '*/*'
    //         },
    //         redirect: 'follow'
    //     };
    //     let response = await fetch(url, request);
    //     if(response.ok){
    //         const json = await response.json();
    //         const token = JSON.parse(json.response).Token;
    //         sessionStorage.setItem('token', token);
    //     }
    // }

    async desencriptar(textoEncriptado: string): Promise<string>{
        let url=`${environment.backendUrl}/api/SolidariaUtility/Decrypt`;
        if(!textoEncriptado)
            return "";
        url += `?pParametro=${textoEncriptado}`;
        // let token = sessionStorage.getItem('token');
        let request: RequestInit={
            method: 'GET',
            // headers: {
            //     'Authorization': `Bearer ${token}`,
            //     'Content-Type': 'application/json',
            //     'Access-Control-Allow-Origin': '*',
            //     'Accept': '*/*'
            // }
        };
        let response = await fetch(url, request);
        if(response.ok){
            return (await response.text());
        }
        else
            return textoEncriptado;
    }

    async UsersAccess(textoEncriptado: string): Promise<number> {
        let url = `${environment.backendUrl}/api/SolidariaUtility/UsersAccess`;
        if (!textoEncriptado)
            return 0;  
        url += `?CodUsuario=${textoEncriptado}`;
        // let token = sessionStorage.getItem('token');
        let request: RequestInit = {
            method: 'GET',
            // headers: {
            //     'Authorization': `Bearer ${token}`,
            //     'Content-Type': 'application/json',
            //     'Access-Control-Allow-Origin': '*',
            //     'Accept': '*/*'
            // }
        };
        let response = await fetch(url, request);
        if (response.ok) {
            const responseData = await response.json();
            return responseData; 
        } else {
            return -1; 
        }
    }
}